export { NoteHighlighter, NoteHighlighterProps } from './NoteHighlighter';
